export * from './ott-list.component';
